import React from "react";
import { useTranslation } from "react-i18next";
import { useParams, Navigate, generatePath } from "react-router-dom";
import track from "react-tracking";

import DetailsView from "components/Journey/DetailsView";
import JourneyActions from "components/Journey/JourneyActions";
import { PAGE_PATHS } from "config/routes";
import { usePageNavigationHeader } from "contexts/LayoutContext/LayoutContext";
import { Loader } from "elements";
import useFetchJourney from "hooks/api/journeys/useFetchJourney/useFetchJourney";
import { usePageTracking } from "utils/tracking";

type Params = {
  id: string;
};

const IndexPage = () => {
  usePageTracking();
  const { t } = useTranslation();
  const { id } = useParams<Params>();

  if (!id) {
    return <Navigate to={{ pathname: generatePath(PAGE_PATHS.HOME_PAGE) }} />;
  }

  const journeyQuery = useFetchJourney(parseInt(id));

  usePageNavigationHeader(
    {
      title: t("navigation.your_trip"),
      backPath: generatePath(PAGE_PATHS.JOURNEYS_PAGE),
      actionSpace: journeyQuery.data ? <JourneyActions journey={journeyQuery.data} /> : null,
    },
    [journeyQuery.data?.id]
  );

  if (journeyQuery.isPending) {
    return <Loader />;
  } else if (journeyQuery.isError) {
    return <Navigate to={{ pathname: generatePath(PAGE_PATHS.HOME_PAGE) }} />;
  } else {
    return <DetailsView journey={journeyQuery.data} />;
  }
};

export default track({ page_type: "Journey.Index" })(IndexPage);
